<div
  *ngIf="open()"
  class="fixed inset-0 z-[1000] flex items-center justify-center modal-overlay p-3 bg-black/60"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'user-manual-title'"
  (click)="onBackdrop($event)"
>
  <div
    class="wallet-modal-shell w-full max-w-4xl h-[60vh] md:h-[70vh] flex flex-col overflow-hidden"
    (click)="$event.stopPropagation()"
  >
    <div class="flex items-center justify-between mb-4">
      <h2
        id="user-manual-title"
        class="text-[#F4F7FC] text-sm font-extrabold uppercase italic tracking-wide"
      >
        {{ options.title }}
      </h2>
      <button
        *ngIf="options.closable"
        (click)="close()"
        class="wallet-modal-close"
        aria-label="Close"
      >
        <svg viewBox="0 0 24 24" class="h-4 w-4">
          <path
            d="M6 6l12 12M18 6L6 18"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>

    <!-- CONTENT -->
    <div class="relative flex-1 flex items-center justify-center overflow-hidden">
      <!-- Prev -->
      <button
        (click)="prev()"
        [disabled]="currentIndex() === 0"
        class="absolute left-2 md:left-4 z-20 h-10 w-10 md:h-12 md:w-12 flex items-center justify-center rounded-full bg-[#030204] border border-[#120810] text-[#F2A56F] shadow-md disabled:opacity-20 hover:bg-[#030204] transition"
      >
        <svg
          viewBox="0 0 24 24"
          class="h-5 w-5 md:h-6 md:w-6"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <path
            d="M15 18l-6-6 6-6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <!-- IMAGE -->
      <div class="w-full h-full flex items-center justify-center relative">
        <ng-container *ngFor="let s of steps(); index as i; trackBy: trackByIndex">
          <div
            *ngIf="i === currentIndex()"
            class="w-full h-full flex items-center justify-center"
          >
            <img loading="lazy"
              [src]="
                steps()[currentIndex()].imageUrl ||
                steps()[currentIndex()].imageUrlLg
              "
              class="max-h-full max-w-full object-contain border border-[#120810] rounded-lg"
            />
          </div>
        </ng-container>
      </div>

      <!-- Next -->
      <button
        (click)="next()"
        [disabled]="currentIndex() === steps().length - 1"
        class="absolute right-2 md:right-4 z-20 h-10 w-10 md:h-12 md:w-12 flex items-center justify-center rounded-full bg-[#030204] border border-[#120810] text-[#F2A56F] shadow-md disabled:opacity-20 hover:bg-[#030204] transition"
      >
        <svg
          viewBox="0 0 24 24"
          class="h-5 w-5 md:h-6 md:w-6"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <path
            d="M9 18l6-6-6-6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
<!-- <div class="h-1 w-full bg-white/5">
        <div
          class="h-full bg-gradient-to-r from-[#9B0F3B] to-[#C71650] transition-all duration-500"
          [style.width.%]="progress()"
        ></div>
      </div> -->

<!-- <div
      class="flex items-center justify-between px-6 py-4 bg-black/20 backdrop-blur-md"
    >
      <span
        class="hidden md:block text-[10px] text-white/40 tracking-widest uppercase"
      >
        Nav: Arrows | Exit: Esc
      </span>

      <div class="flex items-center gap-3 ml-auto">
        <button
          (click)="prev()"
          [disabled]="currentIndex() === 0"
          class="px-5 py-2 rounded-lg text-sm font-medium text-white/70 hover:text-white transition-colors disabled:opacity-20"
        >
          PREVIOUS
        </button>

        <button
          *ngIf="currentIndex() < steps().length - 1"
          (click)="next()"
          class="px-6 py-2 rounded-lg bg-white text-black text-sm font-bold shadow-lg hover:brightness-110 transition-all transform active:scale-95"
        >
          CONTINUE
        </button>

        <button
          *ngIf="currentIndex() === steps().length - 1"
          (click)="close()"
          class="px-6 py-2 rounded-lg bg-gradient-to-r from-[#9B0F3B] to-[#C71650] text-white text-sm font-bold shadow-lg shadow-[#C71650]/20 hover:brightness-110 transition-all transform active:scale-95"
        >
          FINISH
        </button>
      </div>
    </div> -->
